import { VStack } from '@montel/montelpro-shared-components-v2';
import GetCachedPermissionsTool from './GetCachedPermissionsTool';
import PurgeCachedPermissionsByApplication from './PurgeCachedPermissionsByApplication';
import PurgeCachedPermissionsTool from './PurgeCachedPermissionsTool';

export const PermissionCacheTools: React.FC = () => (
	<VStack gap="md">
		<GetCachedPermissionsTool />
		<PurgeCachedPermissionsTool />
		<PurgeCachedPermissionsByApplication />
	</VStack>
);
